import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于鬼父在线的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => toggleFaq(index)}
              >
                <h4 className="text-sm font-medium text-foreground-800 pr-4">
                  {item.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-colors flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-400'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}